import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { App } from '@df/core/app';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { OnChange } from '@df/ng/on-change';
import { Login } from '@df/session/login/login.interfaces';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { InputWrapBodyDirective } from 'projects/app-default/src/app/ui/form/input-wrap-body.directive';
import { InputWrapComponent } from 'projects/app-default/src/app/ui/form/input-wrap.component';
import { ValidateEmailExistsDirective } from 'projects/app-default/src/app/ui/form/validate/validate-email-exists.directive';
import { FormWizardStepAbstract } from '../../../../../ui/form/wizard/step/form-wizard-step.abstract';
import { FormWizardStepComponent } from '../../../../../ui/form/wizard/step/form-wizard-step.component';
import { ILoginViewLayoutContent } from '../../../../view/layout/login-view-layout.component';
import { LoginFormTradeComponent } from '../../login-form-trade.component';
import { MatchCheckDirective } from '@df/ui/form/match-check.directive';
@Component({
    selector: 'login-form-trade-step-1',
    templateUrl: './login-form-trade-step-1.component.html',
    styleUrls: ['./login-form-trade-step-1.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        GridModule,
        ICmsClientModule,
        InputWrapComponent,
        InputWrapBodyDirective,
        MatchCheckDirective,
        MuiInputDirective,
        TranslationModule,
        ValidateEmailExistsDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormTradeStep1Component extends FormWizardStepAbstract {
    @Input()
    data: Login.IRegisterFormData;
    @Input()
    content: ILoginViewLayoutContent;
    @Input()
    @OnChange<string | undefined>(function (value) {
        this.emailChange.emit(value);
    })
    email: string | undefined;
    @Output()
    emailChange = new EventEmitter<string | undefined>();
    constructor(
        app: App,
        changeDetectorRef: ChangeDetectorRef,
        formWizardStepComponent: FormWizardStepComponent,
        readonly loginFormTradeComponent: LoginFormTradeComponent
    ) {
        super(app, changeDetectorRef, formWizardStepComponent);
    }
    get exists() {
        return this.loginFormTradeComponent.hasAccount();
    }
}
